import { createContext } from 'react';

interface DropdownContextType {
    isOpen: boolean;
    toggleDropdown: () => void;
    closeDropdown: () => void;
}

const DropdownContext = createContext<DropdownContextType | undefined>(
    undefined
);

export default DropdownContext;
